import { PaginatedSearchDTO } from '@uefa-shared/contracts'
import { IsOptional, IsString } from 'class-validator'

export class SVRSiteTypeSearchDTO extends PaginatedSearchDTO {
  @IsOptional()
  @IsString()
  name?: string
}
